import { forwardRef, type SelectHTMLAttributes } from "react";

import { fieldClasses } from "./Input";
import { cn } from "./lib/cn";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, ...rest },
  ref,
) {
  return (
    <select ref={ref} className={cn("h-10", fieldClasses, className)} {...rest}>
      {children}
    </select>
  );
});
